export function removeScheme(url: string): string {
  return url.replace(/^https?:\/\//, '');
}
